import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

const SundayCityTour = () => {
    const tourItems = [
        {
            title: "Lalbagh Botanical Garden",
            description:
                "Start the day with a calm and refreshing nature walk.",
            image: "/assets/lalbagh.jpg",
        },
        {
            title: "Cubbon Park",
            description:
                "Experience Bangalore’s green spaces in the city center.",
            image: "/assets/cubbon.jpg",
        },
        {
            title: "Vidhana Soudha (Outside View)",
            description: "A must-visit stop for photos and city identity.",
            image: "/assets/vidhana.jpg",
        },
        {
            title: "Bangalore Palace",
            description: "Explore the cultural and royal history of Bangalore.",
            image: "/assets/palace.jpg",
        },
        {
            title: "Sree Tirumalagiri Lakshmi Venkateshwara Swamy Temple",
            description:
                "End the tour with a peaceful visit to this well-known temple, offering a spiritual and serene experience on Sunday.",
            image: "/assets/temple.jpg",
        },
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-orange-100 to-yellow-100 py-12">
            <div className="container mx-auto px-4">
                <h1 className="text-4xl font-bold text-center mb-12 text-gray-800">
                    Sunday City Tour (Temple Special)
                </h1>
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={30}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: true }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    }}
                    className="pb-12"
                >
                    {tourItems.map((item, index) => (
                        <SwiperSlide key={index}>
                            <Link
                                to="/sunday-city-tour-details"
                                className="block h-full"
                            >
                                <div className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300 h-full">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-48 object-cover"
                                    />
                                    <div className="p-6">
                                        <h2 className="text-xl font-semibold mb-3 text-gray-800">
                                            {item.title}
                                        </h2>
                                        <p className="text-gray-600">
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default SundayCityTour;
